import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { toplinks } from '@shared/interfaces/interfaces';

@Component({
  selector: '[app-ddtopnavlinks]',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './ddtopnavlinks.component.html',
  styleUrl: './ddtopnavlinks.component.scss'
})
export class DdtopnavlinksComponent {
  @Input() links: toplinks[] = [];
}
